import { Controller } from '@hotwired/stimulus';
import { cancel } from 'helpers/dom-helper';
import useResetForm from 'stimulus-hooks/use-reset-form';

const CURRENT_OPTION_RADIO_VALUE = '1';
const FOLLOWING_OPTION_RADIO_VALUE = '2';

export default class extends Controller<HTMLElement> {
  static targets = ['form', 'allOption', 'currentOption', 'radio'];

  static values = {
    sameDay: { type: Boolean, default: true },
    sameRrule: { type: Boolean, default: true },
  };

  connect(): void {
    useResetForm(this, { element: this.formTarget });
  }

  // We want to force check the radio button, else it will be stateless.
  modalShown() {
    this.sameRruleValueChanged(this.sameRruleValue);
  }

  sameDayValueChanged(value: boolean) {
    if (this.hasAllOptionTarget) {
      this.allOptionTarget.hidden = !value;
    }
  }

  sameRruleValueChanged(value: boolean) {
    if (!this.currentOptionRadio || !this.followingOptionRadio) return;

    if (value) {
      this.currentOptionTarget.hidden = false;
      this.currentOptionRadio.checked = true;
    } else {
      this.currentOptionTarget.hidden = true;
      this.followingOptionRadio.checked = true;
    }
  }

  /**
   * This method is called when the user selects an option and submits the "update type" form. This method also
   * dispatches the `skd-event-update-type:submit` event which is used by the main event form to show the loading state
   * and submit the form details to the server.
   */
  submit(event: Event) {
    cancel(event);

    const { target } = event;
    if (!(target instanceof HTMLFormElement)) return;

    const formData = new FormData(target);
    const updateType = formData.get('event[update_type]');

    this.dispatch('submit', {
      detail: { updateType, targetId: this.targetFormId },
      bubbles: true,
    });

    $(this.element).modal('hide');
  }

  resetForm(): void {
    this.element.removeAttribute('data-form-id');
  }

  private get targetFormId() {
    return this.element.dataset.formId;
  }

  private get currentOptionRadio() {
    return this.radioTargets.find(({ value }) => value === CURRENT_OPTION_RADIO_VALUE);
  }

  private get followingOptionRadio() {
    return this.radioTargets.find(({ value }) => value === FOLLOWING_OPTION_RADIO_VALUE);
  }

  declare readonly sameRruleValue: boolean;
  declare readonly formTarget: HTMLFormElement;
  declare readonly allOptionTarget: HTMLElement;
  declare readonly hasAllOptionTarget: boolean;
  declare readonly currentOptionTarget: HTMLElement;
  declare readonly radioTargets: HTMLInputElement[];
}
